export default __webpack_public_path__ + "static/media/fileUpload.8208b740.svg";